import {  postRequest } from '@/libs/axios';
export const createTrajectoryConfig = (params) => {
    return postRequest('/ndt/transportCarInfo/insert', params)
}
export const updateTrajectoryConfig = (params) => {
    return postRequest('/ndt/transportCarInfo/update', params)
}
export const deleteTrajectoryConfig = (params) => {
    return postRequest('/ndt/transportCarInfo/delete', params)
}
export const getTrajectoryConfigDetail = (params) => {
    return postRequest('/ndt/transportCarInfo/detail', params)
}
export const insertTrajectoryTask = (params) => {
    return postRequest('/ndt/transportTask/insert', params)
}
export const updateTrajectoryTask = (params) => {
    return postRequest('/ndt/transportTask/update', params)
}
export const deleteTrajectoryTask = (params) => {
    return postRequest('/ndt/transportTask/delete', params)
}
export const pageTrajectoryTask = (params) => {
    return postRequest('/ndt/transportTask/page', params)
}
export const pageTrajectoryTaskDetails = (params) => {
    return postRequest('/ndt/transportTaskDetails/page', params)
}

export const getTransportTaskStatistics = (params) => {
    return postRequest('/ndt/transportTask/taskStatistics', params)
}
